// src/components/privacy/PrivacyPolicy.js
import React from 'react';
import './PrivacyPolicy.css';
import './MobilePrivacyPolicy.css';

const PrivacyPolicy = () => {
  // Privacy policy content sections
  const policySections = [
    {
      id: 'collection',
      title: '1. 個人情報の取得',
      content: '当社は、本サービスの提供に必要な範囲で、氏名、住所、電話番号、メールアドレス、生活保護に関する情報等、特に慎重な取り扱いが求められる個人情報を、適正かつ公正な手段により取得します。'
    },
    {
      id: 'use',
      title: '2. 個人情報の利用目的',
      content: '取得した個人情報は、以下の目的のために利用します。\n* 生活保護支援サービスの提供・運営\n* お問い合わせへの対応\n* ご本人の同意に基づく、提携先事業者への紹介\n* サービス向上のための分析・アンケート調査\n* 本サービスに関連する情報提供\n* 当社サービスの改善・新サービスの開発\n* その他、上記利用目的に付随する目的'
    },
    {
      id: 'sensitive',
      title: '3. センシティブ情報の取扱いについて',
      content: '当社は、生活保護に関する情報を含むセンシティブ情報について、特に慎重に取り扱い、法令およびガイドラインに基づき適切な管理を行います。 これらの情報は、明確な同意を得た場合にのみ取得・利用し、同意なく第三者に提供することはありません。'
    },
    {
      id: 'sharing',
      title: '4. 個人情報の第三者提供',
      content: '当社は、以下の場合を除き、個人情報を第三者に提供することはありません。\n* ご本人の明示的な同意がある場合\n* 法令に基づく場合\n* 人の生命、身体または財産の保護のために必要がある場合\n* 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合\n* 国または地方公共団体の公的事務に協力する必要がある場合\n\nまた、当社は、お客様に提供できる物件がない場合やその他サービス提供が困難な場合に限り、事前にご本人の同意を得たうえで、生活保護支援に関連する適切な第三者（不動産会社、福祉事業者等）に個人情報を提供することがあります。 この際、提供する情報は必要最小限とし、提供先には適切な個人情報保護措置を義務付け、再提供や目的外利用を禁止します。'
    },
    {
      id: 'outsourcing',
      title: '5. 個人情報の委託',
      content: '当社は、業務委託先に個人情報の取り扱いを委託する場合、委託先を適切に監督し、個人情報の安全管理が確保されるよう努めます。'
    },
    {
      id: 'security',
      title: '6. 個人情報の安全管理',
      content: '当社は、個人情報への不正アクセス、漏えい、滅失または毀損の防止その他の個人情報の安全管理のために、必要かつ適切な措置を講じます。'
    },
    {
      id: 'rights',
      title: '7. 個人情報の開示、訂正、利用停止、削除等',
      content: 'ご本人から個人情報に関する開示、訂正、利用停止、削除等の請求があった場合には、本人確認の上、法令に従い速やかに対応します。'
    },
    {
      id: 'changes',
      title: '8. プライバシーポリシーの変更',
      content: '当社は、必要に応じて本ポリシーの内容を変更することがあります。 変更後のプライバシーポリシーは、当サイトに掲載した時点から効力を生じます。'
    },
    {
      id: 'contact',
      title: '9. お問い合わせ窓口',
      content: '本ポリシーに関するお問い合わせは、以下までお願いいたします。\n\n【お問い合わせ先】\nハンターサイト株式会社\n住所：〒101-0021 東京都千代田区外神田1丁目11番6号 小暮ビル4階\n電話番号：03-6737-7589\nメールアドレス：hogoland@huntersite.jp\n受付時間：年中無休10:00～19:00（水・日を除く）'
    }
  ];

  return (
    <div className="privacy-section">
      <div className="privacy-container">
        <div className="frame-policy">
          <div className="ttl">
            <h2 className="privacy-title">プライバシーポリシー</h2>
          </div>
          
          <div className="privacy-introduction">
            <p className="intro-text">
              ハンターサイト株式会社（以下「当社」といいます）は、当社が提供する生活保護支援サービス（以下「本サービス」といいます）において取得する個人情報について、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定め、適切な取り扱い及び保護に努めます。
            </p>
          </div>

          <div className="policy-sections">
            {policySections.map((section) => (
              <div key={section.id} className="policy-item">
                <div className="policy-header">
                  <h3 className="policy-title">{section.title}</h3>
                </div>
                <div className="policy-content">
                  <p className="policy-content-text">{section.content}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="privacy-footer">
            <p className="updated-date">制定日：2025年3月21日 最終更新日：2025年3月21日</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;